import React from "react";
import { Helmet } from "react-helmet";
import environment from "src/environment";

const cookieScripts = {
  otAutoBlock: {
    test:
      "https://cdn.cookielaw.org/consent/d57e8176-145a-4e21-86da-415db7dfba0c-test/OtAutoBlock.js",
    prod:
      "https://cdn.cookielaw.org/consent/d57e8176-145a-4e21-86da-415db7dfba0c/OtAutoBlock.js",
  },
  domainScript: {
    test: "d57e8176-145a-4e21-86da-415db7dfba0c-test",
    prod: "d57e8176-145a-4e21-86da-415db7dfba0c",
  },
};

export const CookiesAgreement = (): JSX.Element => {
  const env =
    environment.REACT_APP_ENVIRONMENT === "production" ? "prod" : "test";

  return (
    <Helmet>
      <script
        type="text/javascript"
        src={cookieScripts.otAutoBlock[env]}
      ></script>
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script={cookieScripts.domainScript[env]}
      ></script>
      <script type="text/javascript">{`function OptanonWrapper() {}`}</script>
    </Helmet>
  );
};
